import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForgotPasswordMutation } from "../../store/api/authApi";
import styles from "./Auth.module.css";
import Logo from "../../components/Logo";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [forgotPassword, { isLoading }] = useForgotPasswordMutation();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    try {
      await forgotPassword(email).unwrap();
      setSuccess("A password reset link has been sent to your email address.");
      setEmail("");
    } catch (err) {
      setError(
        err?.data?.message ||
          err?.error ||
          "Failed to send reset link. Please try again.",
      );
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        {/* ── Left brand panel ── */}
        <div className={styles.brandPanel}>
          <div className={styles.brandInner}>
            <Logo height={100} scale={3} />

            <p className={styles.brandTagline}>
              Forgot your password? No worries — we'll get you back into your
              circle in no time.
            </p>
            <div className={styles.brandIcon}>
              <svg
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  width="48"
                  height="48"
                  rx="14"
                  fill="rgba(251,152,51,0.15)"
                />
                <path
                  d="M24 14a6 6 0 0 1 6 6v2H18v-2a6 6 0 0 1 6-6z"
                  stroke="#fb9833"
                  strokeWidth="2"
                  strokeLinejoin="round"
                  fill="none"
                />
                <rect
                  x="14"
                  y="22"
                  width="20"
                  height="14"
                  rx="3"
                  stroke="#fb9833"
                  strokeWidth="2"
                  fill="none"
                />
                <circle cx="24" cy="30" r="2" fill="#fb9833" />
              </svg>
            </div>
          </div>
        </div>

        {/* ── Right form panel ── */}
        <div className={styles.formPanel}>
          <div className={styles.formInner}>
            <div className={styles.formHeader}>
              <h2 className={styles.heading}>Forgot Password</h2>
              <p className={styles.subheading}>
                Enter your email and we'll send you a reset link
              </p>
            </div>

            {error && <p className={styles.error}>{error}</p>}
            {success && <p className={styles.successMsg}>{success}</p>}

            <form onSubmit={handleSubmit} noValidate>
              <div className={styles.formGroup}>
                <div className={styles.fieldGroup}>
                  <label className={styles.label} htmlFor="email">
                    Email Address
                  </label>
                  <input
                    id="email"
                    type="email"
                    placeholder="Enter your registered email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    disabled={isLoading}
                    className={styles.input}
                  />
                </div>

                <button
                  type="submit"
                  className={styles.button}
                  disabled={isLoading}
                >
                  {isLoading ? "Sending…" : "Send Reset Link"}
                </button>
              </div>
            </form>

            <div className={styles.dividerRow}>
              <span className={styles.dividerLine} />
              <span className={styles.dividerText}>or</span>
              <span className={styles.dividerLine} />
            </div>

            <p className={styles.footerNote}>
              Remembered your password?{" "}
              <Link to="/login" className={styles.footerLink}>
                Sign In
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
